import React from 'react';
import { ImSpinner2 } from 'react-icons/im';

export default function Loading() {
  return (<ImSpinner2 className='mx-auto animate-spin text-violet-700 text-4xl mt-12 mb-24' />)
}
